<template>
  <v-col
    sm="12"
    md="6"
    lg="4"
  >
    <v-card
      class="pointer-card"
      :disabled="canWrite"
      tile
      outlined
      raised
    >
      <schedule-card
        :schedule="schedule"
        :project="getName(project.path)"
        :project-id="project.id_proj"
        :path="project.path"
        :not-found="project.not_found == 1"
        :while-time="whileTime"
        :project-selected.sync="selected"
        @refresh="refresh"
      />
    </v-card>
  </v-col>
</template>

<script>
// Components
import scheduleCard from "../Common/ScheduleCard";

// Tools
const pathInfo = require("path");

export default {
  components: {
    scheduleCard,
  },
  props: {
    whileTime: {
      type: Number,
      default: 0,
    },
    project: {
      type: Object,
      default: () => {},
    },
    schedule: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      deleted: false,
      selected: {},
    };
  },
  computed: {
    canWrite() {
      const writeSchedule = this.$store.state.user.permissions.indexOf(6) !== -1;
      return !writeSchedule;
    },
  },
  watch: {
    selected: function (val) {
      this.$emit("update:selected-player", val);
    },
  },
  methods: {
    getName(path) {
      return pathInfo.basename(path, ".zip");
    },
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style>
.pointer-card {
  cursor: pointer;
}
</style>
